import {Logo} from "../../components/specific/Logo.tsx";
import { FaEnvelope } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import {PiMicrosoftOutlookLogoFill} from "react-icons/pi";

export default function PasswordResetSuccessPage() {
    const emailApps = [
        {
            name: "Gmail",
            icon: SiGmail,
            url: "https://mail.google.com",
            iconColor: "text-red-600"
        },
        {
            name: "Outlook",
            icon: PiMicrosoftOutlookLogoFill,
            url: "https://outlook.live.com",
            iconColor: "text-blue-600"
        },
        {
            name: "Email",
            icon: FaEnvelope,
            iconColor: "text-gray-600"
        }
    ];

    return (
        <div className="min-h-screen flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center space-y-8">
                <div className="flex justify-center">
                    <Logo />
                </div>
                
                <div className="space-y-4">
                    <h1 className="text-3xl font-bold leading-tight text-gray-900">
                        Gelukt! We hebben een link gestuurd naar je e-mailadres
                    </h1>
                    <p className="text-base text-gray-600">
                        Klik op de link in de e-mail om je wachtwoord opnieuw in te stellen.
                    </p>
                </div>

                <div className="space-y-3">
                    <p className="text-sm text-gray-500">
                        Klik op een link hieronder om naar je inbox te gaan
                    </p>
                    <div className="flex items-center justify-center gap-6">
                        {emailApps.map((app) => {
                            const Icon = app.icon;
                            return (
                                <a
                                    key={app.name}
                                    href={app.url}
                                    target={app.name === "Email" ? undefined : "_blank"}
                                    rel={app.name === "Email" ? undefined : "noopener noreferrer"}
                                    className="flex flex-col items-center justify-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors underline decoration-gray-300 hover:decoration-gray-400"
                                >
                                    <Icon className={`h-8 w-8 ${app.iconColor}`} />
                                    <span>{app.name}</span>
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
